import { render, staticRenderFns } from "./UpdateStaffGroupPopUp.vue?vue&type=template&id=b0b37418&scoped=true"
import script from "./UpdateStaffGroupPopUp.vue?vue&type=script&lang=js"
export * from "./UpdateStaffGroupPopUp.vue?vue&type=script&lang=js"
import style0 from "./UpdateStaffGroupPopUp.vue?vue&type=style&index=0&id=b0b37418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b37418",
  null
  
)

export default component.exports